import { useTranslation } from 'react-i18next';

import { ProductTypeCodes } from 'entities/progress';
import { useAppSelector } from 'hooks';

import EarlyPaymentPreferences from './Configuration/EarlyPaymentPreferences';
import { getActiveProductsTypeCodes } from './Progress/selectors';
import SmartExchange from './Configuration/SmartExchange';
import OnboardingTabHeader from './OnboardingTabHeader';

const ConfigurationTab = () => {
  const { t } = useTranslation('configuration');

  const activeProducts = useAppSelector(getActiveProductsTypeCodes);

  return (
    <div>
      <OnboardingTabHeader
        title={t('configuration:title')}
        subTitle={t('configuration:description')}
      />
      <div className="p-6">
        {activeProducts.includes(ProductTypeCodes.payments) && (
          <>
            <SmartExchange />
            <EarlyPaymentPreferences />
          </>
        )}
      </div>
    </div>
  );
};

export default ConfigurationTab;
